import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

import './mixins/global';
import * as components from './components';
import i18n from './plugins/translations';
import plugins from './plugins';
import store from './store';

plugins.init();

// eslint-disable-next-line no-new
new Vue({
    components: {
        ...components,
    },
    el: '#app',
    i18n,
    data() {
        return {
            navIsOpen: false,
            searchIsOpen: false,
        };
    },
    mounted() {
        window.Laravel.notifications.forEach(notification =>
            this.$notify(notification));
    },
    computed: {
        ...mapState('modal', [
            'modal',
            'videoUrl',
        ]),

        ...mapState('filters', ['query']),
    },
    methods: {
        ...mapMutations('modal', [
            'setModal',
            'setVideoModal',
        ]),

        confirm(message, event) {
            const currentTarget = event.currentTarget || event;
            const href = currentTarget.href;

            this.$modal.show('dialog', {
                title: null,
                text: message,
                buttons: [
                    {
                        title: '<span>Continue</span>',
                        default: true,
                        class: 'btn btn-primary',
                        handler: () => {
                            if (!href) {
                                currentTarget.submit();
                                return;
                            }

                            window.location = href;
                        },
                    },
                    {
                        class: 'btn btn-link',
                        title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    },
                ],
            });
        },

        historyBack() {
            window.history.back();
        },

        navLinkToggle(e) {
            e.currentTarget.classList.toggle('open');
        },

        navOpen() {
            this.navIsOpen = true;
        },

        navToggle() {
            this.navIsOpen = !this.navIsOpen;
            this.searchIsOpen = !this.searchIsOpen;
        },

        searchClose() {
            if (window.innerWidth <= 768) {
                return;
            }

            this.searchIsOpen = false;
        },

        async searchToggle() {
            this.searchIsOpen = !this.searchIsOpen;
        },
    },
    store,
});
